// src/components/HeroSection.js
import { useEffect, useState } from "react";
import heroBg from "../../assests/images/heroSection.png";
// import Home from "../../assests/images/person1.png";
import Call from "../../assests/images/call1.png";
import Favicon from "../../assests/images/favicon.png";
import Path from "../../assests/images/Path.png";
import AOS from 'aos';
import 'aos/dist/aos.css'
import { Helmet } from "react-helmet";
import HorizontalSvgScroller from "../header/horizontalSvgScroller";
import whatsup from '../../assests/whatsup.png';
import { FaWhatsapp } from "react-icons/fa";
import Home from '../../assests/hme.png';
import './style.css';

const HeroSection = () => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation only once
        });
    }, []);
    const phoneNumber = "919343389975";
    return (
        <div className="bg-[#000]">
            <Helmet>
                <title>Software Company  | Top #1 IT Staffing company - TekIT </title>
                <meta name="description" content="On-demand Trusted IT staffing solutions company, TekIT Solution offers Premier staffing solutions specialised for IT Services in hiring top IT talent resources." />
                <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Business Solutions, Web Development, Mobile App Development, Software Development, Digital Marketing,  E-Commerce development, Offshore Development Center, Managed Services" />
            </Helmet>

            <section
                className="relative w-full bg-cover bg-center py-12 px-4 lg:px-24 font-recoleta lg:h-[600px] overflow-hidden"
            >
                {/* Seamless Scrolling Background */}
                {/* <div className={`absolute inset-0 bg-[url${Home}] bg-repeat-x bg-[length:auto_100%] animate-scrollClouds z-0`} /> */}
                <div className="absolute inset-0 w-[200%] h-full flex z-0 animate-smoothScroll">
                    <img src={Home} alt="cloud-bg" className="w-1/2 h-full object-cover" />
                    <img src={Home} alt="cloud-bg" className="w-1/2 h-full object-cover" />
                </div>

                <div className="relative z-10 max-w-8xl mx-auto w-[90%] flex flex-col lg:flex-row items-center justify-between mt-[40px]">
                    <div className="text-center justify-self-center md:text-left space-y-6 mt-10 md:mt-16 w-full">
                        <h1
                            className="text-[56px] 2xl:text-[40px] lg:text-[32px] text-[#09588D] leading-snug font-recoleta text-center"
                            style={{ fontWeight: '900' }}
                            data-aos="fade-up"
                        >
                            Empowering Clients with Next-Gen Tech & Skilled Talent, Unified!
                        </h1>
                        <p
                            className="text-gray-900 2xl:text-[24px] lg:text-[20px] text-[48px] px-2 md:px-0 justify-self-center text-center"
                            data-aos="fade-up"
                        >
                            At TekIT, we cultivate innovation and convert challenges into cutting-edge technology solutions.
                        </p>

                        {/* Call Button */}
                        {/* <div className="hidden md:block relative lg:w-[200px] w-[300px] lg:h-[52px] h-[80px] justify-self-center" data-aos="fade-right">
                            <img
                                src={Call}
                                alt="Call Background"
                                className="w-full h-full object-contain"
                            />
                            <button
                                // onClick={() => window.open(`https://wa.me/${phoneNumber}`, "_blank")}
                                onClick={() => {
                                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                                    const whatsappUrl = isMobile
                                      ? `https://wa.me/${phoneNumber}`
                                      : `https://web.whatsapp.com/send?phone=${phoneNumber}`;
                                    window.open(whatsappUrl, "_blank");
                                  }}
                                
                                className="absolute inset-0 flex items-center pl-4 pr-6 justify-start text-white font-recoleta text-sm md:text-base"
                            >
                                <p className="lg:w-6 lg:h-6 w-10 h-10 lg:mr-3 mr-5 mb-2">
                                    <FaWhatsapp className="lg:text-[30px] text-[35px]" />
                                </p>
                                <div className="leading-tight">
                                    <div className="lg:text-[18px] text-[34px]">Request</div>
                                    <div className="font-semibold lg:text-[18px]  text-[34px] w-[77px] whitespace-nowrap">Consult Call</div>
                                </div>
                                <div>
                                    <img
                                        src={Favicon}
                                        alt="Phone Icon"
                                        className="lg:w-18 w-28 lg:h-[79px] h-[120px] mb-[8px] lg:ml-[44px] ml-[70px]"
                                    />
                                </div>
                            </button>
                        </div> */}
                        <div className="block relative lg:w-[200px] w-[300px] lg:h-[52px] h-[80px] mx-auto" data-aos="fade-right">
    <img
        src={Call}
        alt="Call Background"
        className="w-full h-full object-contain"
    />
    <button
        onClick={() => {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            const whatsappUrl = isMobile
              ? `https://wa.me/${phoneNumber}`
              : `https://web.whatsapp.com/send?phone=${phoneNumber}`;
            window.open(whatsappUrl, "_blank");
        }}
        className="absolute inset-0 flex items-center pl-4 pr-6 justify-start text-white font-recoleta text-sm md:text-base"
    >
        <p className="lg:w-6 lg:h-6 w-10 h-10 lg:mr-3 mr-5 mb-2">
            <FaWhatsapp className="lg:text-[30px] text-[35px]" />
        </p>
        <div className="leading-tight">
            <div className="lg:text-[18px] text-[34px]">Request</div>
            <div className="font-semibold lg:text-[18px] text-[34px] w-[77px] whitespace-nowrap">Consult Call</div>
        </div>
        <div>
            <img
                src={Favicon}
                alt="Phone Icon"
                className="lg:w-18 w-28 lg:h-[79px] h-[120px] mb-[8px] lg:ml-[44px] ml-[70px]"
            />
        </div>
    </button>
</div>

                    </div>
                </div>

                <div className="mt-20">
                    <HorizontalSvgScroller />
                </div>
            </section>

        </div>
    );
};

export default HeroSection;
